import React from 'react';
import HiringHeading from './HiringHeading';
import PositionComponent from './PositionComponent';
import { Link } from 'react-router-dom';
import { FaArrowRight } from 'react-icons/fa6';

interface HiringSectionProps {
	heading: string;
	subheading: string;
	positions: Array<{
		id: number;
		process: string;
		count: number;
		badge?: string;
		positionData?: {
			assessmentPending?: number;
			interviewing?: number;
			rejected?: number;
		};
		unseenApplicationCount?: number;
	}>;
	linkUrl: string;
	linkText: string;
	logoSrc?: string;
}

const HiringSection: React.FC<HiringSectionProps> = ({
	heading,
	subheading,
	positions,
	linkUrl,
	linkText,
	logoSrc,
}) => {
	const handleLink = () => {
		window.location.href = linkUrl;
	};
	console.log('positions======>', positions);
	return (
		<div className="flex md:max-w-[1280px] px-4 xl:px-[80px] flex-col gap-[8px] mb-4 mt-4 w-full">
			<HiringHeading heading={heading} subheading={subheading} logoSrc={logoSrc} />
			<div className="p-6 rounded-[16px] bg-[#FFF]">
				<div className="grid grid-cols-2 md:flex self-stretch gap-6 overflow-auto w-full">
					{positions.map(position => {
						console.log('position1111', position);
						return (
							<PositionComponent
								key={position.id}
								process={position.process}
								count={position.count}
								badge={position.badge}
								unseenApplicationsCount={position.unseenApplicationCount}
								// positionData={position.positionData}
							/>
						);
					})}
				</div>
				{/* add space between text and underline */}
				<Link
					to={linkUrl}
					className="flex py-2 font-inter text-[16px] font-[500] leading-[24px] text-[#6698FA] items-center underline underline-offset-[5px]"
				>
					{/* <div className="flex items-center underline underline-offset-[5px] gap-2"> */}
					{linkText}
					{/* </div> */}
				</Link>
			</div>
		</div>
	);
};

export default HiringSection;
